/* eslint-disable react/jsx-max-depth */
import React, { useEffect, useContext, useState } from 'react';
import Card from '../../components/elements/Card';
import styles from './styles.scoped.css';
import { AppContext } from '../../contexts';
import ButtonLink from '../../components/elements/ButtonLink';
import Modal from '../../components/elements/Modal';
import PropTypes from 'prop-types';
import FormRegistrasiSekaligus from './FormRegistrasiSekaligus';
import { useDispatch, useSelector } from 'react-redux';
import { submitRegistration } from './actions';
import Button from '../../components/elements/Button';
// import moment from 'moment';

export function RegistrasiSekaligus(
  // {
  //   handleSubmit = () => { }
  // }
) {
  const dispatch = useDispatch();

  const { setBreadcrumbs } = useContext(AppContext);
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('');


  useEffect(() => {
    setBreadcrumbs(['Registrasi Pangkalan', 'Registrasi Sekaligus']);
  }, []);

  const {
    dataSubmitRegistration,
    messageSubmitRegistration
  } = useSelector((s) => s.merchantRegistrations);


  // const handleDownloadDataFailRegist = () => {
  //   let a = document.createElement('a');
  //   a.href = dataSubmitRegistration?.url?.fileUrl;
  //   // a.setAttribute('download', `${moment().format('YYYY-MM-DD')} Sebagian data gagal`);
  //   a.click();
  //   setOpenModal(false);
  // };

  useEffect(() => {
    if(afterSubmit && messageSubmitRegistration !== '' && messageSubmitRegistration !== undefined){
      setOpenModal(true);
      setModalMode('fail');
    }else if(afterSubmit && dataSubmitRegistration?.failed?.length > 0){
      setOpenModal(true);
      setModalMode('successWithFail');
    }else if (afterSubmit && dataSubmitRegistration?.failed?.length === 0){
      setOpenModal(true);
      setModalMode('success');
    }
  },[dataSubmitRegistration,messageSubmitRegistration]);

  return(
    <main className={styles.bulk}>
      <Card className={styles.card}>
        <FormRegistrasiSekaligus
          onSubmit={(values) => dispatch(submitRegistration(values, setAfterSubmit(true)))}
        />
      </Card>
      <Modal className={styles['modal-reg-success']} open={openModal}>
        <span onClick={() => setOpenModal(false)}>
          <img className={styles['close-icon-modal']} src="assets/ic-close.svg"/>
        </span>
        <br/>
        {modalMode === 'successWithFail' ? <h5>Sebagian data berhasil diunggah</h5> :
          <h5>Unggah file {modalMode === 'success' ? 'berhasil' : 'gagal'}</h5>
        }
        <hr className={styles.separatirModal}/>
        <br/>
        {modalMode === 'successWithFail' && <p>
          {dataSubmitRegistration?.success + ' '}
         dan <strong>{' ' + dataSubmitRegistration?.failed.length} data gagal</strong>.
          Data yang gagal dapat dilihat pada tab <strong>Gagal</strong>.
          <span> Segera perbaiki data yang gagal dan unggah kembali.</span>
        </p>}
        {modalMode === 'fail' && <p>File yang diunggah memiliki kekurangan data, segera
lengkapi data dan unggah kembali.</p>}
        <br/>
        <br/>
        {modalMode === 'success' && <ButtonLink
          className={styles['action-btn-modal']}
          to={'/merchant/registrasi-pangkalan'}
          type="primary"
        >
          Ok
        </ButtonLink>}
        {/* {modalMode === 'successWithFail' && <Button
          className={styles['action-btn-modal']}
          onClick={() => handleDownloadDataFailRegist()}
          "
        >
          Tutup dan Unduh Data Gagal
        </Button>} */}
        {(modalMode === 'fail' || modalMode === 'successWithFail') && <Button
          className={styles['action-btn-modal']}
          onClick={() => setOpenModal(false)}
        >
          Ok
        </Button>
        }
      </Modal>
    </main>
  );
}

RegistrasiSekaligus.propTypes = {
  handleSubmit: PropTypes.func
};
export default RegistrasiSekaligus;
